import type { ElementType } from "react";

import { styled, Typography } from "@mui/material";

import { BasicButton } from "components/buttons/basic-button";

import { AssistantGuideLinkProps } from "./types";

export const AssistantGuideButton = styled(
  BasicButton
)<AssistantGuideLinkProps>(({ theme }) => ({
  height: "auto",
  minHeight: theme.spacing(9),
  padding: theme.spacing(3, 4),
  borderRadius: theme.shape.borderRadius[2],
  borderColor: theme.palette.custom.semantic.border.default,
  textAlign: "left",
  justifyContent: "flex-start",
  ...theme.typography.subtitle8,
  "& .MuiButton-endIcon": {
    marginLeft: "auto",
    paddingLeft: theme.spacing(2),
  },
}));

export const AssistantGuideHint = styled(Typography)(({ theme }) => ({
  display: "block",
  color: theme.palette.custom.semantic.text.muted,
}));

export const StyledAssistantGuideListTypographyDisplay = styled(Typography)<{
  component?: ElementType;
}>({
  display: "block",
});
